var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Exportar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.bodega_id,
                        expression: "form.bodega_id"
                      }
                    ],
                    attrs: { name: "bodega", id: "bodega" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "bodega_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.bodegas, function(bodega) {
                    return _c(
                      "option",
                      { key: bodega.id, domProps: { value: bodega.id } },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(bodega.descripcion) +
                            "\n                                "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "bodega" } }, [_vm._v("Sucursal")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-8" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione...",
                      id: "cliente",
                      options: _vm.clientes,
                      multiple: "",
                      label: "nombre"
                    },
                    on: {
                      search: _vm.searchClientes,
                      input: _vm.inputClientes
                    },
                    model: {
                      value: _vm.selectedClientes,
                      callback: function($$v) {
                        _vm.selectedClientes = $$v
                      },
                      expression: "selectedClientes"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "cliente" } }, [
                    _vm._v("Clientes")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione...",
                      id: "supervisores_id",
                      options: _vm.supervisores,
                      multiple: "",
                      label: "nombre"
                    },
                    on: {
                      input: _vm.inputSupervisores,
                      search: _vm.searchSupervisores
                    },
                    model: {
                      value: _vm.selectedSupervisores,
                      callback: function($$v) {
                        _vm.selectedSupervisores = $$v
                      },
                      expression: "selectedSupervisores"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "supervisor_id" } }, [
                    _vm._v("Supervisores")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione...",
                      id: "vendedor_id",
                      options: _vm.vendedores,
                      label: "descripcion"
                    },
                    on: {
                      input: _vm.inputVendedores,
                      search: _vm.searchVendedores
                    },
                    model: {
                      value: _vm.selectedVendedores,
                      callback: function($$v) {
                        _vm.selectedVendedores = $$v
                      },
                      expression: "selectedVendedores"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "vendedor_id" } }, [
                    _vm._v("Vendedores")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_fecha",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Personalizada")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "fecha" } }, [_vm._v("Fecha")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("label", { attrs: { for: "por_entregar" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.por_entregar,
                      expression: "form.por_entregar"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "por_entregar",
                    value: "S",
                    id: "por_entregar"
                  },
                  domProps: { checked: _vm._q(_vm.form.por_entregar, "S") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "por_entregar", "S")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Por entregar")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "pendientes" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.por_entregar,
                      expression: "form.por_entregar"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "por_entregar",
                    value: "N",
                    id: "pendientes"
                  },
                  domProps: { checked: _vm._q(_vm.form.por_entregar, "N") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "por_entregar", "N")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Pendientes")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "todas_entregar" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.por_entregar,
                      expression: "form.por_entregar"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "por_entregar",
                    value: "T",
                    id: "todas_entregar"
                  },
                  domProps: { checked: _vm._q(_vm.form.por_entregar, "T") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "por_entregar", "T")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Todas")])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card__content" },
        [
          _c(
            "vs-table",
            {
              ref: "tableSelect",
              attrs: {
                search: "",
                "max-items": _vm.maximoItems == "" ? 20 : _vm.maximoItems,
                data: _vm.registros,
                pagination: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var data = ref.data
                    return _vm._l(data, function(tr, index) {
                      return _c(
                        "vs-tr",
                        { key: index, attrs: { data: tr } },
                        _vm._l(_vm.columnas, function(columna) {
                          return _c(
                            "vs-td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !columna.hidden,
                                  expression: "!columna.hidden"
                                }
                              ],
                              key: columna.nombre + index,
                              attrs: {
                                data: _vm.lodash.get(
                                  data[index],
                                  columna.nombre
                                )
                              }
                            },
                            [
                              columna.nombre === "numero_documento"
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn--text btn-info",
                                      on: {
                                        click: function($event) {
                                          return _vm.verPedido(data[index])
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.lodash.get(
                                              data[index],
                                              columna.nombre
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                : columna.nombre === "por_entregar"
                                ? _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "por_entregar_" + data[index].id
                                      }
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          id: "por_entregar_" + data[index].id
                                        },
                                        domProps: {
                                          checked:
                                            data[index].por_entregar === "S"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.changeEntregar(
                                              data[index]
                                            )
                                          }
                                        }
                                      }),
                                      _c("span")
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          columna.money
                                            ? _vm.moneyFormat(
                                                _vm.lodash.get(
                                                  data[index],
                                                  columna.nombre
                                                )
                                              )
                                            : _vm.lodash.get(
                                                data[index],
                                                columna.nombre
                                              )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ]
                          )
                        }),
                        1
                      )
                    })
                  }
                }
              ])
            },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c(
                      "input-field",
                      {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "###",
                            expression: "'###'"
                          }
                        ],
                        staticClass: "input-field--stretch ml-3",
                        attrs: {
                          type: "tel",
                          id: "maximoItems",
                          placeholder: ""
                        },
                        model: {
                          value: _vm.maximoItems,
                          callback: function($$v) {
                            _vm.maximoItems = $$v
                          },
                          expression: "maximoItems"
                        }
                      },
                      [_c("span", [_vm._v("Cantidad de registros:")])]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "thead" },
                _vm._l(_vm.columnas, function(columna) {
                  return _c(
                    "vs-th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !columna.hidden,
                          expression: "!columna.hidden"
                        }
                      ],
                      key: columna.nombre,
                      attrs: {
                        "sort-key": columna.sortable ? columna.nombre : null
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(columna.descripcion) +
                          "\n                    "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Informe de Entrega de Premios")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la Consulta")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4056b31e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4056b31e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/InformeEntregaPremios.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4056b31e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/InformeEntregaPremios.vue
// module chunks = 0